import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class FilterRow extends PureComponent {
  render () {
    const { icon, children, title, className } = this.props;

    return (
      <div className={`row align-items-center mb-4 mb-sm-3 ${className}`}>
        <label className='col-12 col-sm-3'>
          <span className='icon-wrapper'>
            <FontAwesomeIcon icon={icon} />
          </span>
          {title}
        </label>
        <div className='col-12 col-sm-9'>
          {children}
        </div>
      </div>
    );
  }
}

FilterRow.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  className: PropTypes.string
};

FilterRow.defaultProps = {
  className: ''
};



// WEBPACK FOOTER //
// ./src/components/common/AdvancedFilter/FilterRow/index.js